<template>
    <v-container>
        <div class="text-h4 mb-5 mt-5">Países</div>
            <v-card :loading="loading">
                <v-card-title>
                    <v-text-field
                        v-model="buscar"
                        append-icon="mdi-file-search-outline"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                <v-dialog v-model="dialogEditarPais" max-width="500px" persistent>
                    <v-card>
                    <v-card-title>Editar país</v-card-title>
                    <v-card-text>
                        <v-row class="mt-2" dense>
                            <v-col cols="12">
                                <v-text-field label="Código país" filled color="blue-grey lighten-2" v-model="paisEditar.country_code" disabled/>
                            </v-col>
                            <v-col cols="12">
                                <v-select label="Nivel de seguridad" filled :items="niveles" v-model="nuevoNivel" color="blue-grey lighten-2"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="error" text @click="dialogEliminar = true">Eliminar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogEditarPais = false">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="edicionPais()">Aceptar</v-btn>
                    </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-data-table :headers="headers" :items="paises" :search="buscar">
                    <template v-slot:item.acciones="{ item }">
                        <v-icon @click="prepararDialogEditar(item)">mdi-pencil</v-icon>
                    </template>
                    <template v-slot:item.nivel_seguridad="{ item }">
                        <v-chip :color="getColorNivelSeguridad(item.nivel_seguridad)" outlined pill small>
                            {{ getValorNivelSeguridad(item.nivel_seguridad) }}
                        </v-chip>
                    </template>
                </v-data-table>
            </v-card>
        </div>
        <v-speed-dial v-model="fab" fixed direction="top" :transition="transition" style="bottom: 37px; right: 30px;">
            <template v-slot:activator>
                <v-btn v-model="fab" color="accent" dark fab>
                    <v-icon v-if="fab">mdi-close</v-icon>
                    <v-icon v-else>mdi-plus</v-icon>
                </v-btn>
            </template>
            <v-btn fab dark small color="indigo" @click="dialogNuevoPais = true">
                <v-icon>mdi-earth-plus</v-icon>
            </v-btn>
        </v-speed-dial>
        <v-dialog v-model="dialogNuevoPais" max-width="500px" persistent>
            <v-card>
                <v-card-title>Añadir país</v-card-title>
                <v-card-text>
                    <v-row class="mt-2" dense>
                        <v-col cols="12">
                            <v-text-field 
                                label="Código país"  
                                color="blue-grey lighten-2" 
                                v-model="codigoNuevoPais"
                                filled
                                @blur="$v.codigoNuevoPais.$touch()"
                                @input="$v.codigoNuevoPais.$touch()"
                                :error-messages="errorCodigo"/>
                        </v-col>
                        <v-col cols="12">
                            <v-select label="Nivel de seguridad" filled :items="niveles" v-model="nivelNuevoPais" color="blue-grey lighten-2"></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="finCreacionPais()">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="creacionPais()" :disabled="this.$v.nivelNuevoPais.$invalid || this.$v.codigoNuevoPais.$invalid">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogEliminar" persistent max-width="380">
            <v-card>
                <v-card-title class="headline">¡Atención!</v-card-title>
                <v-card-text>¿Estás seguro de que quieres eliminar este país?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogEliminar = false">Cancelar</v-btn>
                    <v-btn color="error" text @click="eliminarPais()">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import { mapActions} from 'vuex';
    import { required, minLength, maxLength  } from 'vuelidate/lib/validators';
    import axios from 'axios';
    axios.defaults.withCredentials = true;
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    export default {
        name: 'Paises',
        data: () => ({
            fab: false,
            transition: 'slide-y-reverse-transition',
            paises: [],
            buscar: '',
            headers: [
                {
                    text: 'Código país',
                    align: 'start',
                    filterable: true,
                    sortable: true,
                    value: 'country_code'
                },
                {
                    text: 'Nivel de seguridad',
                    filterable: true,
                    sortable: true,
                    value: 'nivel_seguridad',
                },
                { 
                    text: '',
                    filterable: false,  
                    sortable: false,
                    value: 'acciones'
                }
            ],
            niveles: ['De confianza', 'Riesgo medio', 'Riesgo alto'],
            loading: false,
            dialogEditarPais: false,
            paisEditar: {},
            nuevoNivel: '',
            dialogNuevoPais: false,
            codigoNuevoPais: '',
            nivelNuevoPais: '',
            dialogEliminar: false
        }),
        validations: {
            codigoNuevoPais: { required, minLength: minLength(2), maxLength: maxLength(2)},
            nivelNuevoPais: { required }
        },
        methods: {    
            ...mapActions(['setSnackbar']),
            getColorNivelSeguridad(nivel){
                if (nivel === 0){return 'grey darken-1'}
                else if (nivel === 1){return 'success'}
                else if (nivel === 2){return 'orange darken-2'}
                else if (nivel === 3){return 'error'}
            },
            getValorNivelSeguridad(nivel){
                if (nivel === 0){return 'Desconocido'}
                else if (nivel === 1){return 'De confianza'}
                else if (nivel === 2){return 'Riesgo medio'}
                else if (nivel === 3){return 'Riesgo alto'}
            },
            cambioFormatoNivelPais(nivel){
                if (nivel === 'De confianza'){nivel = 1;}
                else if (nivel === 'Riesgo medio'){nivel = 2;}
                else if (nivel === 'Riesgo alto'){nivel = 3;}
                return nivel;
            },
            prepararDialogEditar(pais){
                this.paisEditar = pais;
                this.nuevoNivel = this.getValorNivelSeguridad(pais.nivel_seguridad);
                this.dialogEditarPais = true;
            },
            edicionPais(){
                axios.patch('/api/paises/'+ this.cambioFormatoNivelPais(this.nuevoNivel), this.paisEditar).then(response => {
                    this.paises[this.paises.indexOf(this.paisEditar)].nivel_seguridad = this.cambioFormatoNivelPais(this.nuevoNivel);
                    this.dialogEditarPais = false;
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'success',
                        mensaje: 'Datos actualizados correctamente'
                    });
                }).catch(error => { 
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'error',
                        mensaje: 'Error. No se han podido actualizar los datos'
                    }); 
                });
            },
            eliminarPais(){
                axios.delete('/api/paises/'+ this.paisEditar.id).then(response => {
                    this.paises.splice(this.paises.indexOf(this.paisEditar), 1);
                    this.dialogEliminar = false;
                    this.dialogEditarPais = false;
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'success',
                        mensaje: 'El país ha sido eliminado correctamente'
                    });
                }).catch(error => { 
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'error',
                        mensaje: 'Error. El país no se han podido eliminar correctamente'
                    });
                });
            },
            creacionPais(){
                let nuevoPais = {
                    codigo: this.codigoNuevoPais,
                    nivel: this.cambioFormatoNivelPais(this.nivelNuevoPais)
                };
                
                axios.post("/api/paises", nuevoPais).then(respuesta => {
                    axios.get("/api/paises").then(respuesta => {
                        this.paises = respuesta.data;
                    }).catch(error =>{
                        this.setSnackbar({
                            snackbar: true,
                            tipo: 'error',
                            mensaje: 'Error. No se han podido recuperar los países'
                        }); 
                    });
                    this.finCreacionPais();
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'success',
                        mensaje: 'El país ha sido creado correctamente'
                    });
                }).catch( error => {
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'error',
                        mensaje: 'Error. El país no se han podido crear correctamente'
                    });
                });
            },
            finCreacionPais(){
                this.dialogNuevoPais = false;
                this.codigoNuevoPais = '';
                this.nivelNuevoPais = '';
                this.$v.$reset();
            }
        },
        mounted() {
            this.loading = true;
            axios.get("/api/paises").then(respuesta => {
                this.loading = false;
                this.paises = respuesta.data;
            }).catch(error =>{
                this.loading = false;
                this.setSnackbar({
                    snackbar: true,
                    tipo: 'error',
                    mensaje: 'No se han podido recuperar los países'
                });
            });
        },
        computed:{
            errorCodigo() {
                if (this.$v.codigoNuevoPais.$dirty){ //comprobación de si se ha hecho clic en el campo
                    if (this.$v.codigoNuevoPais.$invalid && !this.$v.codigoNuevoPais.$minLength && !this.$v.codigoNuevoPais.$maxLength){ //comprobación de si el campo es de la medida que pertoca
                        return 'El código de país tiene el siguiente formato: ES';
                    }
                }
            }
        }
    }
</script>